import "./resource.css";
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "antd";
import { Box, Button, CircularProgress } from "@mui/material";
import Shift from "../../components/Shift/Shift";
import { format } from "date-fns";
import Modal from "react-modal";
import Clients from "../Modal/Clients/AddClients";
import { useSearchParams } from "react-router-dom";

const ResourceTracker = ({
  days,
  gridData,
  handleCellClick,
  handleDragStart,
  handleDrop,
  handleDragOver,
  items,
  handleMenuClick,
  handleRightClick,
  dragStatus,
  length,
  setLength,
  duplicateMode,
  disabledCells,
  connection,
  isConnected,
  clients,
  getClients,
}: any) => {
  const [open, setOpen] = useState(false);
  const [hide, setHide] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const addNewRow = () => {
    setLength((prevLength: any) => {
      const newLength: any = prevLength + 1;
      return newLength;
    });
  };

  const captureRef = React.useRef(null);
  const cellRefs = React.useRef<Record<string, HTMLDivElement | null>>({});

  const [highlightedCell, setHighlightedCell] = useState<string | null>(null);

  const reorderedDays = [...days.slice(-1), ...days.slice(0, -1)];

  const openModalforClients = () => {
    setOpen(true);
  };
  const scrollToCell = (colIndex: number, rowIndex: number) => {
    const key = `${colIndex}-${rowIndex}`;
    const cell = cellRefs.current[key];

    if (!cell) return;

    cell.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });

    setHighlightedCell(key);

    setTimeout(() => {
      setHighlightedCell(null);
    }, 3000);
  };

  useEffect(() => {
    getClients();
  }, [days]);

  if (connection) {
    connection.on("UpdateClientsFromGrid", () => {
      getClients();
    });
  }
useEffect(() => {
  if (Object.keys(gridData).length === 0) return;

  const row = searchParams.get("row");
  const col = searchParams.get("col");

  // Ignore if either parameter is missing
  if (row === null || col === null) return;

  const rowIndex = Number(row);
  const colIndex = Number(col);

  // Ignore invalid numbers
  if (Number.isNaN(rowIndex) || Number.isNaN(colIndex)) return;

  setTimeout(() => {
    scrollToCell(colIndex, rowIndex);
  }, 300);
}, [gridData, searchParams]);

  return (
    <>
      {!isConnected && (
        <div className="overlay">
          <Box className="loading-container">
            <CircularProgress className="loading-spinner" />
          </Box>
        </div>
      )}
      <div className="grid-container" ref={captureRef}>
        {reorderedDays.map((day: any, index: any) => (
          <div
            key={index}
            className={`grid-header ${index === 0 && hide && "sticky-client"}`}
            onClick={index === 0 ? () => openModalforClients() : undefined}
            style={{
              backgroundColor: duplicateMode ? "#afd09e" : "#ccf1b8",
              cursor: index === 0 ? "pointer" : "",
              zIndex: index === 0 && hide ? 2 : 1,
            }}
          >
            {index === 0 ? "Clients" : format(day.day, "EEEE, dd MMMM yyyy")}
          </div>
        ))}
        {Array.from({ length: length }).map((_, rowIndex) =>
          reorderedDays.map((day: any, shiftedColIndex: number) => {
            const colIndex = (shiftedColIndex + 7) % days.length;
            const clientInfo = clients.find(
              (client: any) =>
                rowIndex >= client.startRow - 1 && rowIndex <= client.endRow - 1
            );
            return (
              <Dropdown
                key={`${day.date}-${colIndex}-${rowIndex}`}
                menu={{
                  items,
                  onClick: handleMenuClick,
                }}
                trigger={[gridData[`${colIndex}-${rowIndex}`] && "contextMenu"]}
              >
                <div
                  key={`${colIndex}-${rowIndex}`}
                  ref={(el) => {
                    cellRefs.current[`${colIndex}-${rowIndex}`] = el;
                  }}
                  className={`grid-item ${
                      highlightedCell === `${colIndex}-${rowIndex}` ? "grid-item-highlight" : ""
                    } ${
                    dragStatus[`${colIndex}-${rowIndex}`] === "success"
                      ? "success-style"
                      : dragStatus[`${colIndex}-${rowIndex}`] === "failed"
                      ? "failed-style"
                      : ""
                  } ${colIndex === 7 && hide && "sticky-client"}
                  ${colIndex === 7 && "client-info"}`}
                  onDrop={(event) =>
                    handleDrop(colIndex, rowIndex, event, day.day)
                  }
                  onDragOver={handleDragOver}
                  onClick={() =>
                    handleCellClick(colIndex, rowIndex, day.date, day.day)
                  }
                  onContextMenu={(event) =>
                    handleRightClick(colIndex, rowIndex, event)
                  }
                  style={{
                    cursor: duplicateMode ? "grab" : "default",
                    backgroundColor: disabledCells.some(
                      (cells: any) =>
                        colIndex === cells.colIndex &&
                        rowIndex === cells.rowIndex
                    )
                      ? "#f5f5f5"
                      : "",
                    border: disabledCells.some(
                      (cells: any) =>
                        colIndex === cells.colIndex &&
                        rowIndex === cells.rowIndex
                    )
                      ? "2px solid #A2C4C9"
                      : "",
                    ...(shiftedColIndex === 0 && {
                      backgroundColor: clientInfo?.color,
                    }),
                  }}
                >
                  {!gridData[`${colIndex}-${rowIndex}`] && (
                    <div className="text-right">
                      {colIndex === 7 ? (
                        rowIndex === clientInfo?.startRow - 1 ? (
                          <div className="client-name">
                            {clientInfo ? `${clientInfo.clientName}` : ""}
                          </div>
                        ) : null
                      ) : (
                        `${rowIndex + 1}, ${colIndex + 1}`
                      )}
                    </div>
                  )}
                  {gridData[`${colIndex}-${rowIndex}`] && (
                    <>
                      <div
                        draggable
                        onDragStart={(event) =>
                          handleDragStart(colIndex, rowIndex, event)
                        }
                      >
                        <Shift
                          gridData={gridData}
                          colIndex={colIndex}
                          rowIndex={rowIndex}
                          day={day}
                        />
                      </div>
                    </>
                  )}
                </div>
              </Dropdown>
            );
          })
        )}
        <div className="button">
          <Button
            variant="outlined"
            startIcon={
              <FontAwesomeIcon icon={faPlus} size={"5x"} color="#e39865" />
            }
            onClick={addNewRow}
            style={{
              width: "10px",
              borderColor: "black",
              color: "black",
            }}
          />
        </div>
      </div>
      <Modal
        isOpen={open}
        onRequestClose={() => {
          setOpen(false);
          getClients();
        }}
        className="add-modal"
        style={{ overlay: { zIndex: 2 } }}
      >
        <Clients
          connection={connection}
          isConnected={isConnected}
          hide={hide}
          setHide={setHide}
        />
      </Modal>
    </>
  );
};

export default ResourceTracker;
